const finishedScripts = new Map<string, string>();
let generationHeld = false;

export function holdScriptGeneration(held: boolean) {
  generationHeld = held;
}

export function scriptGenerationHeld() {
  return generationHeld;
}

export function rememberFinishedScript(jobId: string, script: string) {
  if (jobId && script.trim()) finishedScripts.set(jobId, script);
}

export function finishedScript(jobId: string) {
  return finishedScripts.get(jobId) || "";
}
